import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import OutputParams from '../../OutputParams';

/**
 * OpenResult 响应渲染器
 */
function OpenResultRenderer({ onSelect }) {
  return (
    <ErrorBoundary
      fallbackRender={() => <div></div>}
      onReset={() => {}}
    >
      <OutputParams
        resultType="OpenResult"
        waitingType="OpenResult"
        onSelect={onSelect}
      />
    </ErrorBoundary>
  );
}

export default OpenResultRenderer;
